module.exports = __webpack_public_path__ + "img/11.6f60b633.jpg";